import http from "@/http";

//put
function put(url, data) {
    return http.put(url, {
        json: JSON.stringify(data),
    });
}
//get
function get(url, data) {
    if (IsURL(url)) {
        http.url = url;
    }
    return http.get(url, {
        params: data,
    });
}
//post
function post(url, data) {
    // console.log(url,data);
    return http.post(url,
        // JSON.stringify(data)
        data
    );
}
//delete
function del(url, data, header) {
    return http.delete(url, {
        headers: header,
        params: data,
    });
}

//url是否为链接
function IsURL(str_url) {
    var strRegex = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
    var re = new RegExp(strRegex);
    if (re.test(str_url)) {
        return true;
    } else {
        return false;
    }
}

export { put, get, post, del };


// WEBPACK FOOTER //
// ./src/static/req/http.js